import type {RemoteMountProps, ShellAccount} from '@wandb/forge-shell-contract';
import React, {createContext, type ReactNode, useContext, useMemo} from 'react';

export type ShellAccountContextValue = {
  // undefined: not resolved yet or not mounted under the Forge shell;
  // null: resolved while signed out or with no accounts.
  selectedAccount: ShellAccount | null | undefined;
  // Mount-prop callbacks; undefined when the shell predates them.
  broadcastUrlAccount: RemoteMountProps['broadcastUrlAccount'];
  selectAccount: RemoteMountProps['selectAccount'];
};

export const ShellAccountContext = createContext<ShellAccountContextValue>({
  selectedAccount: undefined,
  broadcastUrlAccount: undefined,
  selectAccount: undefined,
});

export const useShellAccountContext = () => useContext(ShellAccountContext);

// Memoized so consumers re-render only when an account-related mount prop
// actually changes, not on every mount-prop update.
export const ShellAccountContextProvider = ({
  selectedAccount,
  broadcastUrlAccount,
  selectAccount,
  children,
}: ShellAccountContextValue & {children?: ReactNode}) => {
  const value = useMemo(
    () => ({selectedAccount, broadcastUrlAccount, selectAccount}),
    [selectedAccount, broadcastUrlAccount, selectAccount]
  );
  return (
    <ShellAccountContext.Provider value={value}>
      {children}
    </ShellAccountContext.Provider>
  );
};
